import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { isMobile } from 'react-device-detect'
import { ActiveToggleIcon, InActiveToggleIcon } from './Icons'
import {
  FUNDAMENTAL_TOGGLE_COLOR,
  TOGGLE_INDEX,
} from '../ultils/chart-d3-utils'

const useStyles = makeStyles({
  newToggleGroup: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  newToggleGroupMobile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flexStart',
    marginTop: '20px !important',
  },
  toggleItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginRight: 12,
    cursor: 'pointer',
  },
  toggleIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  toggleTitle: {
    '@media only screen and (min-width: 1200px)': {
      fontSize: 10,
    },
    '@media only screen and (min-width: 1500px)': {
      fontSize: 12,
    },
    '@media only screen and (max-width: 900px)': {
      fontSize: 12,
    },
    lineHeight: '18px',
    fontWeight: 400,
    marginLeft: 8,
  },
})

interface NewToggleGroupProps {
  companyColor?: any
  peerGroupColor?: any
  equityColor?: any
  marketAssetsColor?: any
  assetVolatilityColor?: any
  leverageColor?: any
  unrecognisedRiskStatusColor?: any
  riskEventsColors?: any
  companyText?: any
  peerGroupText?: any
  equityText?: any
  marketAssetsText?: any
  assetVolatilityText?: any
  leverageText?: any
  unrecognisedRiskStatusText?: any
  riskEventsText?: any
  inModal?: boolean
  toggleObj?: any
  setToggleObj?: any
  showPeerGroup?: any
  showCompany?: any
  showEquityPrice?: any
  showMarketValueOfAssets?: any
  showAssetVolatility?: any
  showLeverage?: any
  showUnrecognisedRiskStatus?: any
  showRiskEvents?: any
}

const ChartD3ToggleGroup = ({
  companyColor,
  peerGroupColor,
  equityColor,
  marketAssetsColor,
  assetVolatilityColor,
  leverageColor,
  unrecognisedRiskStatusColor,
  riskEventsColors,
  companyText,
  peerGroupText,
  equityText,
  marketAssetsText,
  assetVolatilityText,
  leverageText,
  unrecognisedRiskStatusText,
  riskEventsText,
  inModal,
  toggleObj,
  setToggleObj,
  showPeerGroup,
  showCompany,
  showEquityPrice,
  showMarketValueOfAssets,
  showAssetVolatility,
  showLeverage,
  showUnrecognisedRiskStatus,
  showRiskEvents,
}: NewToggleGroupProps) => {
  const classes = useStyles()
  const [toggleData, setToggleData] = useState({
    companyValue: true,
    peerGroupValue: false,
    equityValue: false,
    marketValueAssetValue: false,
    assetVolatilityValue: false,
    leverageValue: false,
    unrecognisedRiskStatusValue: true,
    riskEventsValue: true,
  })

  useEffect(() => {
    if (toggleObj) {
      setToggleData({
        companyValue: toggleObj.showCompanyHistory,
        peerGroupValue: toggleObj.showPeerGroup,
        equityValue: toggleObj.showEquityPrice,
        marketValueAssetValue: toggleObj.showMarketValueOfAssets,
        assetVolatilityValue: toggleObj.showAssetVolatility,
        leverageValue: toggleObj.showLeverage,
        unrecognisedRiskStatusValue: toggleObj.showUnrecognisedRiskStatus,
        riskEventsValue: toggleObj.showRiskEvents,
      })
    }
  }, [toggleObj])

  const onToggleItem = (index: number) => {
    const cloned = JSON.parse(JSON.stringify(toggleData))

    index === TOGGLE_INDEX.COMPANY_HISTORY &&
      (cloned.companyValue = !cloned.companyValue)
    index === TOGGLE_INDEX.PEER_GROUP &&
      (cloned.peerGroupValue = !cloned.peerGroupValue)
    index === TOGGLE_INDEX.EQUITY_PRICE &&
      (cloned.equityValue = !cloned.equityValue)
    index === TOGGLE_INDEX.MARKET_VALUE_OF_ASSET &&
      (cloned.marketValueAssetValue = !cloned.marketValueAssetValue)
    index === TOGGLE_INDEX.ASSET_VOLATILITY &&
      (cloned.assetVolatilityValue = !cloned.assetVolatilityValue)
    index === TOGGLE_INDEX.LEVERAGE &&
      (cloned.leverageValue = !cloned.leverageValue)
    index === TOGGLE_INDEX.UNRECOGNISED_RISK_STATUS &&
      (cloned.unrecognisedRiskStatusValue = !cloned.unrecognisedRiskStatusValue)
    index === TOGGLE_INDEX.RISK_EVENTS &&
      (cloned.riskEventsValue = !cloned.riskEventsValue)
    setToggleObj({
      showCompanyHistory: cloned.companyValue,
      showPeerGroup: cloned.peerGroupValue,
      showEquityPrice: cloned.equityValue,
      showMarketValueOfAssets: cloned.marketValueAssetValue,
      showAssetVolatility: cloned.assetVolatilityValue,
      showLeverage: cloned.leverageValue,
      showUnrecognisedRiskStatus: cloned.unrecognisedRiskStatusValue,
      showRiskEvents: cloned.riskEventsValue,
    })
    setToggleData(cloned)
  }

  return (
    <div
      className={
        isMobile ? classes.newToggleGroupMobile : classes.newToggleGroup
      }
      style={{
        justifyContent: inModal ? 'flex-end' : 'flex-start',
        marginTop: inModal ? 20 : 0,
      }}
    >
      {showCompany && (
        <div
          onClick={() => onToggleItem(TOGGLE_INDEX.COMPANY_HISTORY)}
          className={classes.toggleItem}
        >
          <div className={classes.toggleIcon}>
            {toggleData.companyValue ? (
              <ActiveToggleIcon />
            ) : (
              <InActiveToggleIcon />
            )}
          </div>
          <div
            className={classes.toggleTitle}
            style={{
              color: toggleData.companyValue ? companyColor : '#A3A3A3',
            }}
          >
            {companyText}
          </div>
        </div>
      )}

      {showPeerGroup && (
        <div
          onClick={() => onToggleItem(TOGGLE_INDEX.PEER_GROUP)}
          className={classes.toggleItem}
        >
          <div className={classes.toggleIcon}>
            {toggleData.peerGroupValue ? (
              <ActiveToggleIcon />
            ) : (
              <InActiveToggleIcon />
            )}
          </div>
          <div
            className={classes.toggleTitle}
            style={{
              color: toggleData.peerGroupValue ? peerGroupColor : '#A3A3A3',
            }}
          >
            {peerGroupText}
          </div>
        </div>
      )}

      {showEquityPrice && (
        <div
          onClick={() => onToggleItem(TOGGLE_INDEX.EQUITY_PRICE)}
          className={classes.toggleItem}
        >
          <div className={classes.toggleIcon}>
            {toggleData.equityValue ? (
              <ActiveToggleIcon />
            ) : (
              <InActiveToggleIcon />
            )}
          </div>
          <div
            className={classes.toggleTitle}
            style={{ color: toggleData.equityValue ? equityColor : '#A3A3A3' }}
          >
            {equityText}
          </div>
        </div>
      )}

      {showMarketValueOfAssets && (
        <div
          onClick={() => onToggleItem(TOGGLE_INDEX.MARKET_VALUE_OF_ASSET)}
          className={classes.toggleItem}
        >
          <div className={classes.toggleIcon}>
            {toggleData.marketValueAssetValue ? (
              <ActiveToggleIcon />
            ) : (
              <InActiveToggleIcon />
            )}
          </div>
          <div
            className={classes.toggleTitle}
            style={{
              color: toggleData.marketValueAssetValue
                ? marketAssetsColor
                : '#A3A3A3',
            }}
          >
            {marketAssetsText}
          </div>
        </div>
      )}

      {showLeverage && (
        <div
          onClick={() => onToggleItem(TOGGLE_INDEX.LEVERAGE)}
          className={classes.toggleItem}
        >
          <div className={classes.toggleIcon}>
            {toggleData.leverageValue ? (
              <ActiveToggleIcon />
            ) : (
              <InActiveToggleIcon />
            )}
          </div>
          <div
            className={classes.toggleTitle}
            style={{
              color: toggleData.leverageValue ? leverageColor : '#A3A3A3',
            }}
          >
            {leverageText}
          </div>
        </div>
      )}

      {showAssetVolatility && (
        <div
          onClick={() => onToggleItem(TOGGLE_INDEX.ASSET_VOLATILITY)}
          className={classes.toggleItem}
        >
          <div className={classes.toggleIcon}>
            {toggleData.assetVolatilityValue ? (
              <ActiveToggleIcon />
            ) : (
              <InActiveToggleIcon />
            )}
          </div>
          <div
            className={classes.toggleTitle}
            style={{
              color: toggleData.assetVolatilityValue
                ? assetVolatilityColor
                : '#A3A3A3',
            }}
          >
            {assetVolatilityText}
          </div>
        </div>
      )}

      {showUnrecognisedRiskStatus && (
        <div
          onClick={() => onToggleItem(TOGGLE_INDEX.UNRECOGNISED_RISK_STATUS)}
          className={classes.toggleItem}
        >
          <div className={classes.toggleIcon}>
            {toggleData.unrecognisedRiskStatusValue ? (
              <ActiveToggleIcon />
            ) : (
              <InActiveToggleIcon />
            )}
          </div>
          <div
            className={classes.toggleTitle}
            style={{
              color: toggleData.unrecognisedRiskStatusValue
                ? unrecognisedRiskStatusColor
                : '#A3A3A3',
            }}
          >
            {unrecognisedRiskStatusText}
          </div>
        </div>
      )}

      {showRiskEvents && (
        <div
          onClick={() => onToggleItem(TOGGLE_INDEX.RISK_EVENTS)}
          className={classes.toggleItem}
        >
          <div className={classes.toggleIcon}>
            {toggleData.riskEventsValue ? (
              <ActiveToggleIcon />
            ) : (
              <InActiveToggleIcon />
            )}
          </div>
          <div
            className={classes.toggleTitle}
            style={{
              color: toggleData.riskEventsValue ? riskEventsColors : '#A3A3A3',
            }}
          >
            {riskEventsText}
          </div>
        </div>
      )}
    </div>
  )
}

ChartD3ToggleGroup.defaultProps = {
  companyColor: FUNDAMENTAL_TOGGLE_COLOR.COMPANY_HISTORY,
  peerGroupColor: FUNDAMENTAL_TOGGLE_COLOR.PEER_GROUP,
  equityColor: FUNDAMENTAL_TOGGLE_COLOR.EQUITY_PRICE,
  marketAssetsColor: FUNDAMENTAL_TOGGLE_COLOR.MARKET_VALUE_OF_ASSET,
  assetVolatilityColor: FUNDAMENTAL_TOGGLE_COLOR.ASSET_VOLATILITY,
  leverageColor: FUNDAMENTAL_TOGGLE_COLOR.LEVERAGE,
  unrecognisedRiskStatusColor:
    FUNDAMENTAL_TOGGLE_COLOR.UNRECOGNISED_RISK_STATUS,
  riskEventsColors: FUNDAMENTAL_TOGGLE_COLOR.RISK_EVENTS,
  companyText: 'Show company history',
  peerGroupText: 'Show peer group',
  equityText: 'Show Equity Price',
  marketAssetsText: 'Show $USD Market Value of Assets',
  assetVolatilityText: 'Show Asset Volatility',
  leverageText: 'Show Market Value of Leverage',
  unrecognisedRiskStatusText: 'Show Unrecognised Risk Status',
  riskEventsText: 'Show Risk Events',
}

export default ChartD3ToggleGroup
